// removed by extract-text-webpack-plugin
module.exports = {"ChartWithLegend":"_3Xpyd","Legend":"_2mriR","Chart":"uA8y9","small":"_2k0iq","vertical":"_1JvLC","flexChart":"_1iWgZ","horizontal":"_2yK8s"};


//////////////////
// WEBPACK FOOTER
// ./visualizations/components/ChartWithLegend.css
// module id = 490
// module chunks = 3 4 5